import type { ReactNode } from 'react';

function SentMailIcon() {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height="32"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="32"
    >
      <rect height="16" rx="2" width="20" x="2" y="4" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

export interface SocialAuthSuccessProps {
  children: ReactNode;
  title: string;
}

export function SocialAuthSuccess({ children, title }: SocialAuthSuccessProps) {
  return (
    <div className="or-social-auth-success" role="status">
      <span className="or-social-auth-success__icon"><SentMailIcon /></span>
      <h1 className="or-social-auth-success__title">{title}</h1>
      <p className="or-social-auth-success__body">{children}</p>
    </div>
  );
}
